<template>
  <div class="container" :class="!isMobile ? 'pc' : 'mb'">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-close="true"
      :close-image="`${require('../assets/trea/icon-close.png')}`"
      :errorMsg="errorMsg"
      @close="dialogVisible = false"
    />
    <sys-loading :loading="loading" />
    <div class="content">
      <div class="form-container">
        <img class="logo" src="../assets/trea/logo.png" />
        <div class="form">
          <div class="tags">
            <div
              :class="`tag-item-reg ${isRegisterTag ? 'active' : ''}`"
              @click="isRegisterTag = true"
            ></div>
            <div
              :class="`tag-item-login ${!isRegisterTag ? 'active' : ''}`"
              @click="isRegisterTag = false"
            ></div>
          </div>
          <div class="inputs">
            <div class="form-input">
              <img class="icon-input" src="../assets/trea/icon-user.png" />
              <input
                autocomplete="off"
                v-model="form.username"
                placeholder="Tên đăng nhập"
                maxlength="20"
              />
            </div>
            <div class="form-input" v-show="isRegisterTag">
              <img class="icon-input" src="../assets/trea/icon-phone.png" />
              <input
                autocomplete="off"
                v-model="form.phone"
                placeholder="Số điện thoại"
                maxlength="10"
                oninput="value=value.replace(/^\D/, '')"
              />
            </div>
            <div class="form-input">
              <img class="icon-input" src="../assets/trea/icon-password.png" />
              <input
                v-model="form.password"
                type="password"
                autocomplete="new-password"
                placeholder="Mật khẩu"
              />
            </div>
            <div class="form-input" v-show="isRegisterTag">
              <img class="icon-input" src="../assets/trea/icon-email.png" />
              <input
                v-model="form.email"
                autocomplete="off"
                placeholder="Email"
              />
            </div>
            <a
              v-show="!isRegisterTag"
              class="forget-pwd"
              href="https://www.2q.com"
              >Quên mật khẩu ?</a
            >
          </div>
          <div class="action" v-show="!isRegisterTag" @click="submitAction(2)">
            ĐĂNG NHẬP
          </div>
          <v-captcha
            ref="vcaptcha1"
            :dialogVisible="dialogVisible"
            :showCheck="showCheck"
            @cb="handleConfirm"
            :vstyle="
              isMobile
                ? {
                    width: '40vw',
                    height: 'calc(5vw + 35px)',
                    bottom: '-10px',
                    position: 'absolute',
                    zIndex: 9999
                  }
                : { bottom: '-10px', position: 'absolute' }
            "
            :nativeButton="
              isMobile
                ? {
                    width: '43vw',
                    height: 'calc(5vw + 35px)'
                  }
                : {
                    width: '220px',
                    height: '84px'
                  }
            "
          >
            <div class="action" v-show="isRegisterTag" @click="submitAction(1)">
              ĐĂNG KÝ
            </div>
          </v-captcha>
        </div>
      </div>
      <img v-if="isMobile" class="caption" src="../assets/trea/captain.png" />
      <img v-if="isMobile" class="treasure" src="../assets/trea/treaure.png" />
      <div v-if="!isMobile" class="slide-container">
        <div class="slide">
          <div class="slick-slider slider-c slick-initialized" dir="ltr">
            <sys-swiper :swiper-images="swiperYearImg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DOMAIN_INVITE_CODE,
  FORM_VALID_MESSAGE,
  SWIPER_TREA_IMG
} from "../utils/constant";
import { createCustomer, userLogin, userRegister } from "../utils/request";
import { encodePlatformUrl, isMobile, validForm } from "../utils/tools";
import md5 from "js-md5";
import { captcha } from "@/mixins/captcha";

export default {
  name: "Treasure",
  mixins: [captcha],
  data() {
    return {
      isMobile: isMobile(),
      dialogVisible: false,
      loading: false,
      swiperYearImg: SWIPER_TREA_IMG,
      dialogBgi: require("../assets/trea/bgi-dialog.png"),
      isRegisterTag: true,
      errorMsg: {
        title: "",
        content: ""
      },
      form: {
        by: 1,
        username: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
  },
  methods: {
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  overflow-y: hidden;
  height: 100vh;
  font-family: UTMMabella;
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;

  /deep/ .mask-layer {
    .modal {
      width: 50%;
      padding: 280px 0 140px;

      .modal-content {
        width: 60%;
        margin: 0 auto;
      }

      .close-img {
        top: 120px;
        right: 70px;
      }
    }
  }

  .content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 150px;

    .form-container {
      display: flex;
      align-items: center;
      justify-content: center;

      img.logo {
        position: absolute;
        top: 40px;
      }

      .form {
        background-image: url("../assets/trea/bgi-form.png");
        background-size: 100% 100%;
        position: relative;
        width: 520px;
        height: 670px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: flex-end;
        padding-bottom: 70px;
        box-sizing: border-box;

        .tags {
          display: flex;

          .tag-item-login {
            width: 170px;
            height: 65px;
            background-image: url("../assets/trea/bgi-login-normal.png");
            background-size: 100% 100%;
            cursor: pointer;
            &.active {
              width: 170px;
              height: 65px;
              background-image: url("../assets/trea/bgi-login-active.png");
              background-size: 100% 100%;
            }
          }

          .tag-item-reg {
            width: 170px;
            height: 65px;
            background-image: url("../assets/trea/bgi-reg-normal.png");
            background-size: 100% 100%;
            cursor: pointer;
            &.active {
              width: 170px;
              height: 65px;
              background-image: url("../assets/trea/bgi-reg-active.png");
              background-size: 100% 100%;
            }
          }
        }

        .inputs {
          height: 220px;

          .form-input {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background-size: 100% 100%;
            transition: all 0.25s ease;
            border-radius: 15px;
            background: #fcf4e3;
            &:not(:last-child) {
              margin-bottom: 15px;
            }

            img.icon-input {
              position: relative;
              left: 15px;
            }

            input {
              border: none;
              outline-width: 0;
              background-color: transparent;
              height: 40px;
              width: 300px;
              font-family: sans-serif;
              font-weight: 500;
              font-size: 16px;
              color: #8d421d;
              padding: 0;
              text-indent: 2em;
            }
          }
        }

        a.forget-pwd {
          color: #8d421d;
          display: block;
          text-align: center;
          margin-bottom: 20px;
          font-family: sans-serif;
        }

        .action {
          position: absolute;
          width: 220px;
          left: calc(50% - 110px);
          display: flex;
          justify-content: center;
          bottom: -10px;
          padding: 25px 0;
          font-weight: 800;
          font-size: 24px;
          color: #833d29;
          background-image: url("../assets/trea/bgi-btn-reg.png");
          background-size: 100% 100%;
          cursor: pointer;
          border-radius: 20px;
        }
      }
    }

    .slide-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .slide {
        height: 500px;
        width: 500px;

        .slider-c {
          height: 100%;
          width: 100%;
          position: relative;
          background-image: url("../assets/trea/bgi-swiper.png");
          background-size: 100% 100%;
          padding: 0;

          /deep/ .swiper-slide {
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 375px;
              height: 375px;
            }
          }
        }

        .slick-list,
        .slick-slider,
        .slick-track {
          position: relative;
          display: block;
        }

        .slick-slider {
          box-sizing: border-box;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          -webkit-touch-callout: none;
          -khtml-user-select: none;
          -ms-touch-action: pan-y;
          touch-action: pan-y;
          -webkit-tap-highlight-color: transparent;
        }
      }
    }
  }

  input::placeholder {
    color: #8d421d;
    font-width: 400;
  }
}

.container.pc {
  background-image: url("../assets/trea/bgi.jpg");
  background-size: 100% 100%;
}
.container.mb {
  background-image: url("../assets/trea/bgi-h5.jpg");
  background-size: 100% 100%;

  /deep/ .mask-layer {
    .modal {
      max-width: 100%;
      width: 100%;
      height: 55vh;
      padding: 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      .modal-content {
        width: 85%;
        height: 70%;

        .icon-image {
          top: 26vw;
          right: 10vw;
        }
      }
    }
  }

  .content {
    padding: 0;
    display: block;

    .form-container {
      flex-flow: column;
      flex-flow: column;
      justify-content: center;
      align-items: center;

      img.logo {
        position: static;
        width: 70vw;
        margin-top: 3vw;
      }

      .form {
        width: 90%;
        height: 75vh;

        .tags .tag-item-reg,
        .tags .tag-item-login {
          width: 30vw;
          height: 15vw;
        }

        .inputs {
          height: 45vw;

          .form-input {
            width: 70%;
            margin: 0 auto 2vw;
          }
        }

        .action {
          width: 50vw;
          height: 5vw;
          line-height: 5vw;
          left: calc(50% - 25vw);
        }
      }
    }

    img.caption {
      width: 40vw;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    img.treasure {
      width: 40vw;
      position: fixed;
      bottom: 0;
      right: 0;
    }
  }
}

@media only screen and (min-width: 1400px) and (max-width: 1426px) {
  .content {
    padding: 0 50px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Treasure.vue